module.exports = __webpack_public_path__ + "static/pe1-c39cfd23f8ebfc409520a3aa67611ceb.png";